import React from 'react';
import DHL from '../assets/CourierLogos/DHL.png';

function importAll(r) {
    return r.keys().map(r);
}

const images = importAll(require.context('../assets/CourierLogos', false, /\.(png|jpe?g|svg)$/));

function LogosTicker() {
    return (
        <div className="logos-ticker">
            <ul>
                {images.map((img, index) => (
                    <li key={index}>
                        <div className="logo-cntner">
                            {/* Use img.default if the default key exists */}
                            <img src={img.default || img} alt={`Carrier ${index + 1}`} />
                        </div>
                    </li>
                ))}
                <img src={DHL} alt="DHL" />

            </ul>
            <ul>
                {images.map((img, index) => (
                    <li key={index}>
                        <div className="logo-cntner">
                            {/* Use img.default if the default key exists */}
                            <img src={img.default || img} alt={`Carrier ${index + 1}`} />
                        </div>
                    </li>
                ))}
                <img src={DHL} alt="DHL" />

            </ul>
        </div>
    );
}

export default LogosTicker;
